<div id="header-container" class="ml-3 mr-3">
  <h1 id="header-text">{{ title }}</h1>
  <div id="d-flex gap-8">
    <button mat-stroked-button id="cancel-button" class="action-button" mat-dialog-close>{{ cancelButtonLabel }}
    </button>
    <button mat-raised-button color="primary" id="confirm-button" class="action-button"
            [mat-dialog-close]="true">{{ confirmationButtonLabel }}
    </button>
  </div>
</div>
<div mat-dialog-content class="d-flex flex-column gap-8 mh-100">
  <p>{{ message }}</p>

    <div class="gfs-table">
      <ag-grid-angular
        style="height: 100%; width:100%;"
        class="ag-theme-quartz"
        [rowData]="tableData"
        [columnDefs]="colDefinition"
        [autoSizeStrategy]="autoSizeStrategy"
      />
    </div>

</div>
